import Link from 'next/link';

export const SocialIcons = () => {
  return (
    <div className="social-icons">
      <Link href="https://twitter.com/XBorgHQ" target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 18"
          fill="none"
        >
          <path
            d="M17.9525 4.82852C17.9647 5.00934 17.9647 5.19016 17.9647 5.37264C17.9647 10.9331 13.8371 17.3459 6.28966 17.3459V17.3426C4.06013 17.3459 1.8769 16.691 0 15.456C0.324193 15.496 0.65001 15.516 0.97664 15.5169C2.82429 15.5185 4.61913 14.8828 6.07272 13.712C4.31688 13.6778 2.77717 12.5038 2.23928 10.7897C2.85436 10.9114 3.48812 10.8864 4.09181 10.7172C2.17753 10.3206 0.800325 8.59573 0.800325 6.59255C0.800325 6.57422 0.800325 6.55672 0.800325 6.53922C1.37071 6.86503 2.00934 7.04585 2.6626 7.06585C0.859638 5.83011 0.30388 3.37029 1.39265 1.4471C3.47593 4.07607 6.54966 5.67429 9.84928 5.84344C9.51859 4.38188 9.97034 2.85033 11.0364 1.82291C12.689 0.229696 15.2882 0.311356 16.8418 2.0054C17.7607 1.81958 18.6415 1.47377 19.4475 0.983806C19.1412 1.9579 18.5001 2.78534 17.6437 3.31113C18.457 3.2128 19.2517 2.98949 20 2.64868C19.4491 3.49528 18.7552 4.23273 17.9525 4.82852Z"
            fill="#CACACE"
          />
        </svg>
      </Link>
      <Link href="https://discord.com/invite/xborg" target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3599 2.3836C14.7892 2.63041 16.1561 3.06134 17.4308 3.64625C17.4419 3.65101 17.4513 3.65895 17.4568 3.67005C19.7154 6.99213 20.8309 10.7396 20.4139 15.0537C20.4123 15.0719 20.4028 15.0886 20.3879 15.0997C18.6772 16.356 17.0201 17.1187 15.3859 17.6242C15.3599 17.6321 15.3315 17.6226 15.3157 17.6004C14.9381 17.075 14.5952 16.5211 14.2949 15.9393C14.2775 15.9052 14.2933 15.864 14.3288 15.8505C14.8735 15.6449 15.3914 15.3989 15.8897 15.1077C15.9291 15.0846 15.9314 15.0283 15.8952 15.0013C15.7895 14.9227 15.6847 14.8402 15.5846 14.7577C15.5657 14.7426 15.5404 14.7394 15.5191 14.7497C12.2846 16.2441 8.74107 16.2441 5.46794 14.7497C5.44665 14.7402 5.42141 14.7434 5.4033 14.7584C5.30318 14.841 5.19831 14.9227 5.09347 15.0013C5.05721 15.0283 5.06037 15.0846 5.09977 15.1077C5.598 15.3933 6.11594 15.6449 6.65989 15.8513C6.69535 15.8648 6.71192 15.9052 6.69456 15.9393C6.40054 16.5219 6.05761 17.0758 5.6729 17.6012C5.65634 17.6226 5.62876 17.6321 5.60273 17.6242C3.97642 17.1187 2.31934 16.356 0.608665 15.0997C0.594475 15.0886 0.584227 15.0711 0.58265 15.0529C0.234208 11.3213 0.944493 7.54289 3.53732 3.66926C3.54361 3.65895 3.55307 3.65101 3.56411 3.64625C4.83963 3.06056 6.20659 2.62963 7.63504 2.3836C7.66107 2.37963 7.68707 2.39154 7.70048 2.41455C7.87707 2.72723 8.07887 3.12802 8.21527 3.45577C9.72099 3.22563 11.2503 3.22563 12.7876 3.45577C12.9239 3.13515 13.1187 2.72723 13.2945 2.41455C13.3079 2.39074 13.3339 2.37884 13.3599 2.3836ZM7.18265 12.7803C6.19721 12.7803 5.38524 11.8756 5.38524 10.7646C5.38524 9.65348 6.18146 8.74878 7.18265 8.74878C8.19169 8.74878 8.9958 9.66143 8.98003 10.7646C8.98003 11.8756 8.1838 12.7803 7.18265 12.7803ZM13.8283 12.7803C12.8428 12.7803 12.0309 11.8756 12.0309 10.7646C12.0309 9.65348 12.8271 8.74878 13.8283 8.74878C14.8373 8.74878 15.6414 9.66143 15.6257 10.7646C15.6257 11.8756 14.8373 12.7803 13.8283 12.7803Z"
            fill="#CACACE"
          />
        </svg>
      </Link>
      <Link href="https://www.youtube.com/@xborgofficial" target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8253 3.76183C18.682 3.99247 19.3574 4.66792 19.5881 5.52459C20.0164 7.08966 19.9999 10.3516 19.9999 10.3516C19.9999 10.3516 19.9999 13.597 19.5881 15.1621C19.3574 16.0188 18.682 16.6942 17.8253 16.9249C16.2602 17.3367 9.99996 17.3367 9.99996 17.3367C9.99996 17.3367 3.75616 17.3367 2.17462 16.9084C1.31795 16.6778 0.642501 16.0023 0.41186 15.1456C0 13.597 0 10.3351 0 10.3351C0 10.3351 0 7.08966 0.41186 5.52459C0.642501 4.66792 1.33443 3.976 2.17462 3.74536C3.73969 3.3335 9.99996 3.3335 9.99996 3.3335C9.99996 3.3335 16.2602 3.3335 17.8253 3.76183ZM13.2105 10.3347L8.00458 13.3331V7.3364L13.2105 10.3347Z"
            fill="#CACACE"
          />
        </svg>
      </Link>
      <Link href="https://medium.com/xborg-official" target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M18.0499 15.8653C18.0499 20.9463 14.0093 25.0654 9.02479 25.0654C4.0403 25.0654 0 20.9475 0 15.8653C0 10.783 4.04061 6.66544 9.02479 6.66544C14.009 6.66544 18.0499 10.7843 18.0499 15.8653ZM27.9505 15.8653C27.9505 20.6484 25.9301 24.5256 23.438 24.5256C20.9459 24.5256 18.9254 20.6472 18.9254 15.8653C18.9254 11.0834 20.9459 7.205 23.438 7.205C25.9301 7.205 27.9505 11.0834 27.9505 15.8653ZM32 15.8653C32 20.1507 31.2893 23.6245 30.4129 23.6245C29.5364 23.6245 28.8257 20.1495 28.8257 15.8653C28.8257 11.5811 29.5364 8.10602 30.4132 8.10602C31.2899 8.10602 32 11.5801 32 15.8653Z"
            fill="#CACACE"
          />
        </svg>
      </Link>
      {/* <Link href="https://www.twitch.tv/xborgofficial" target="_blank">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M4.40566 -0.000244141L0.834229 3.57118V16.4283H5.11994V19.9998L8.69137 16.4283H11.5485L17.9771 9.99976V-0.000244141H4.40566ZM16.5485 9.28547L13.6914 12.1426H10.8342L8.33423 14.6426V12.1426H5.11994V1.42833H16.5485V9.28547Z"
            fill="#CACACE"
          />
          <path
            d="M14.4046 3.92798H12.9761V8.21369H14.4046V3.92798Z"
            fill="#CACACE"
          />
          <path
            d="M10.4757 3.92798H9.04712V8.21369H10.4757V3.92798Z"
            fill="#CACACE"
          />
        </svg>
      </Link> */}
    </div>
  );
};
